import React from "react";
import PropTypes from "prop-types";
import i18n from "../../lib/i18n";

interface Props {
  locale?: string;
}

export default class TranslateProvider extends React.Component<Props, {}> {
  public static defaultProps: Props = {
    locale: "en",
  };

  public static childContextTypes = {
    translate: PropTypes.func.isRequired,
    locale: PropTypes.string.isRequired,
  };

  public getChildContext() {
    return {
      translate: this.translate,
      locale: this.props.locale,
    };
  }

  public translate = (id: string, values: { [key: string]: any } = {}) => {
    const locale = this.props.locale!;
    return i18n.translate(id, { ...values, locale });
  };

  public render() {
    return React.Children.only(this.props.children);
  }
}



// WEBPACK FOOTER //
// ./frontend/src/common/components/TranslateProvider.tsx